export default {
  data: () => {
    return {
      // Those written with capital letters
      // at the beginning correspond to larger sections.

      // Those in kebab-case correspond to smaller parts
      // of the interface.

      // An future idea could be having nested configuration
      // e.g. Network, Network.nodes
      // Or something like
      // "network/nodes" as a key.
      inputConfiguration: {
        Inputs: ["AA", "PC", "NPC", "ELCC", "PF", "SC", "SSE"],
        Network: ["NPC", "PF", "SC"],
        nodes: ["NPC", "PF", "SC"],
        branches: ["NPC", "PF", "SC"],
        transformers: ["NPC", "PF", "SC"],
        switches: ["NPC", "PF", "SC"],
        Resources: ["AA", "PC", "NPC", "ELCC", "PF", "SC"],
        Demand: ["AA", "PC", "NPC", "ELCC", "PF", "SC"],
        "system-demand-parameters": ["AA", "PC", "ELCC"],
        "nodal-demands": ["NPC", "PF", "SC"],
        "active-power-profile": ["NPC", "PF", "SC"],
        "reactive-power-profile": ["AA", "PC", "NPC", "ELCC", "PF", "SC"],
        voll: ["AA", "PC", "NPC", "ELCC", "PF", "SC"],
        "scaling-factor-for-active-and-reactive-power": ["AA", "PC", "NPC", "ELCC", "PF", "SC"],
        "demand-response": ["AA", "PC", "ELCC"],
        Generators: ["AA", "PC", "NPC", "ELCC", "PF", "SC"],
        "Energy Storage": ["AA", "PC", "NPC", "ELCC", "PF", "SC"],
        Market: ["AA", "PC", "NPC", "ELCC", "PF", "SC"],
        Policies: ["AA", "PC", "NPC", "ELCC"],
        renewables: ["AA"],
        "emission-programs": ["AA", "PC", "NPC", "ELCC"],
        "energy-efficiency": ["AA", "PC"],
        "financial-parameters": ["AA", "PC", "NPC"],
        "Reliability Criteria": ["AA", "PC", "NPC", "ELCC"],
        "planning-criteria": ["AA"],
        "scarcity-prices": ["AA", "PC", "NPC"],
        reserves: ["AA", "PC", "NPC"],
        "elcc-peaker-generator": ["ELCC"],
        Project: ["SSE"],
      },
      keyToShortName: {
        ALTERNATIVE_ANALYSIS: "AA",
        PRODUCTION_COST: "PC",
        NODAL_PRODUCTION_COST: "NPC",
        STACKED_SERVICES_EMULATOR: "SSE",
        ELCC: "ELCC",
        POWER_FLOW: "PF",
        SHORT_CIRCUIT: "SC",
      },
    };
  },
  computed: {
    // computedCaseSettings() {
    //   return this.currentCase ? this.currentCase.settings : {};
    // },
    computedActiveCalculations() {
      const activeCalculations = {};
      Object.keys(this.keyToShortName).forEach((key) => {
        activeCalculations[this.keyToShortName[key]] = this.computedCaseSettings[key]
          ? this.computedCaseSettings[key].active
          : true;
      });
      return activeCalculations;
    },
  },
  methods: {
    /**
     * Returns a boolean indicating if inputName should be visible for
     * the active calculation list.
     *
     * @param {string} inputName
     *
     * @returns {boolean} indicates whether should be visible or not.
     */
    isRequired(inputName) {
      let input = this.inputConfiguration[inputName];
      input = input.map((key) => this.computedActiveCalculations[key]);
      return input.includes(true);
    },
  },
};
